var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size sm_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" })]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c(
            "dt",
            { staticClass: "ellipsis" },
            [
              _vm._t("header", [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("FIELD.REJECT.DETAIL")) +
                    "\n                    "
                )
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "reject_wrap auto_height" }, [
              _c("dl", { staticClass: "dl_select" }, [
                _c("dd", { attrs: { "data-input-type": "select" } }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.comments,
                          expression: "comments"
                        }
                      ],
                      staticClass: "slt_white w100p",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.comments = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v(_vm._s(_vm.$t("FIELD.SELECT.REJECT.REASON")))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.commentList, function(item) {
                        return _c(
                          "option",
                          {
                            key: "commentList" + item.code,
                            domProps: { value: item.code }
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(item.codeName) +
                                "\n                                    "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "rj_title" }, [
                _vm._v(
                  "\n                            " +
                    _vm._s(_vm.$t("FIELD.DESCRIBE.REJECT.REASON")) +
                    "\n                            "
                ),
                _c(
                  "em",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: "" === _vm.comments || "09" === _vm.comments,
                        expression: "'' === comments || '09' === comments"
                      }
                    ],
                    staticClass: "txt_mandatory"
                  },
                  [_vm._v("*")]
                )
              ]),
              _vm._v(" "),
              _c("dl", { staticClass: "rj_textarea" }, [
                _c("dd", { attrs: { "data-input-type": "textarea" } }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.comment,
                        expression: "comment"
                      }
                    ],
                    staticClass: "textarea_ty w100p scroll",
                    attrs: { maxlength: "200" },
                    domProps: { value: _vm.comment },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.comment = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "textarea_counter" }, [
                    _vm._v(_vm._s(_vm.commentLength) + " / 200")
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "btn_modal_wrap topLine" }, [
              _c("div", { staticClass: "btn_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_white",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                                " +
                        _vm._s(_vm.$t("BUTTON.GLOBAL.CANCEL")) +
                        "\n                            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn_blue",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.save()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                                " +
                        _vm._s(_vm.$t("BUTTON.GLOBAL.SAVE")) +
                        "\n                            "
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71f2b0c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71f2b0c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/eur/admin/RejectPopup.vue
// module id = X1bq
// module chunks = 0